var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',{ref:"refAbsenceRequestForm",attrs:{"fields":_vm.fields,"submitText":"Crear"},on:{"submitForm":_vm.submitCreateAbsenceRequest}})}
var staticRenderFns = []

export { render, staticRenderFns }